import { useMainPageStoreList } from '@/features/recommendation-management/main-page/$store-list/hooks/useMainPageStoreList';
import { StoreListTable } from '@/features/recommendation-management/main-page/$store-list/table';
import { createFileRoute, SearchSchemaInput } from '@tanstack/react-router';
import { z } from 'zod';

const sortItemSchema = z.object({
  id: z.enum(['storeNameEng', 'displayPageLabel', 'displayOrder', 'updatedDate', 'requestedDate', 'status']),
  desc: z.boolean(),
});

const MainPageStoreSearchSchema = z.object({
  sort: z
    .preprocess((val) => {
      if (typeof val === 'string') {
        try {
          return JSON.parse(val);
        } catch {
          return undefined;
        }
      }
      return val;
    }, z.array(sortItemSchema))
    .optional(),
  q: z
    .any()
    .transform((val) => (val == null ? undefined : String(val)))
    .optional(),
  page: z.coerce.number().positive().catch(0),
  fetch: z.coerce.number().positive().max(100).catch(10),
  locationId: z.string().catch(''),
});

export const Route = createFileRoute('/(app)/recommendation-management/main-page/$store-list/')({
  component: RouteComponent,
  validateSearch: (search: SearchSchemaInput) => MainPageStoreSearchSchema.parse(search),
});

function RouteComponent() {
  const { mainPageStore, pagination, isLoading } = useMainPageStoreList();
  return <StoreListTable data={mainPageStore} pagination={pagination} loading={isLoading} />;
}
